module.exports = __webpack_public_path__ + "static/basics-mobile-about-update-d6f7ea06f2629f60e9492639e39fc39f.png";